"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _Card = _interopRequireDefault(require("../nav/Card"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

//
//  src/map/GeographyTooltip.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 11/12/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* Lego Components */

/* Lego Toolkit */
var _default = function _default(props) {
  var className = props.className,
      style = props.style,
      children = props.children;
  var styles = useStylesheet();

  if (children == null) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    className: (0, _styling.css)(styles.root, className, style)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      padding: 6
    }
  }, children));
};

exports["default"] = _default;

var useStylesheet = function useStylesheet() {
  var _useTheme = (0, _providers.useTheme)(),
      textBlack = _useTheme.textBlack;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        opacity: 1,
        color: textBlack
      }
    });
  }, [textBlack]);
};